export default "__VITE_ASSET__CWDEaPLJ__"